import { WowJsService } from './services/wowjs.service';
import { DynamicComponentDirective } from './directives/dynamic-component-container.directive';

import { ElectronService } from './services/electron.service';
import { DataService } from './services/data.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NotificationIconComponent } from './components/notification-icon/notification-icon.component';
import { FullscreenModule } from './modules/fullscreen.module/fullscreen.module';
import { PanelModule } from './modules/panel.module/panel.module';

import { PingTestComponent } from './components/ping-test/ping-test.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconInputComponent } from '../core.module/components/icon-input.component/icon-input.component';

import { ControlMessagesComponent } from './components/control-messages/control-messages.component';
import { ValidationService } from './services/validation.service';
import { AuthGuardService } from './services/authguard.service';

// import { OffClickDirective, OffClickService } from './directives/app-offClick.directive';
import { AppFullheightDirective } from './directives/app-fullheight.directive';
import { WindowRef } from './services/window-ref.service';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotFoundComponent } from './components/not-found.component/not-found.component';
import { CountToDirective } from './directives/count-to.directive';
import { GlobalPropertiesService } from './services/global-properties.service';
import { AppItemAppearDirective } from './directives/app-item-appear.directive';
import { SafePipe } from './pipes/safe.pipe';

import { SwiperModule, SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { LetterIconComponent } from './components/letter-icon/letter-icon.component';
// import { ToastrModule, ToastContainerModule, ToastrService } from 'ngx-toastr';

import { ConfirmDialogModule, ConfirmationService } from 'primeng/primeng';
import { DialogModule } from 'primeng/primeng';
import { BytesPipe } from './pipes/bytes.pipe';
import { HHMMSSPipe } from './pipes/hhmmss.pipe';


@NgModule({
  imports: [
    CommonModule,
    SwiperModule,
    FormsModule,
    ReactiveFormsModule,
    PanelModule,
    FullscreenModule,
    // ToastrModule,
    // ToastContainerModule,
    ConfirmDialogModule,
    DialogModule

  ],
  declarations: [
    NotFoundComponent,
    CountToDirective,
    AppItemAppearDirective,
    SafePipe,
    BytesPipe,
    HHMMSSPipe,
    AppFullheightDirective,
    ControlMessagesComponent,
    IconInputComponent,
    PingTestComponent,
    LetterIconComponent,
    NotificationIconComponent,
    DynamicComponentDirective,


  ],
  providers: [],
  exports: [
    NotFoundComponent,
    CountToDirective,
    DynamicComponentDirective,
    AppItemAppearDirective,
    SafePipe,
    BytesPipe,
    HHMMSSPipe,
    SwiperModule,
    AppFullheightDirective,
    ControlMessagesComponent,
    IconInputComponent,
    PingTestComponent,
    LetterIconComponent,
    PanelModule,
    FullscreenModule,
    NotificationIconComponent,
    ConfirmDialogModule,
    DialogModule,
    // ToastrModule
  ]
})
export class CoreModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [
        WindowRef,
        GlobalPropertiesService,
        ValidationService,
        AuthGuardService,
        ConfirmationService,
        DataService,
        ElectronService,
        WowJsService
        // ToastrService
      ]
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/core.module/core.module.ts